// @flow
import {
    CHANGE_FILTER,
    CHANGE_SORT
} from "../common/actionTypes";

const INIT_STATE = {
    filter: {},
    sort: []
};

const User = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CHANGE_FILTER:
            if (action.payload.belongs === "user-list") {
                return {
                    ...state,
                    filter: action.payload.filter
                };
            } else {
                return {
                    ...state
                }
            }

        case CHANGE_SORT:
            return {
                ...state,
                sort: action.payload
            };
        default:
            return state;
    }
};

export default User;
